<template>
    <div>
        <b-modal :id="`cadastro_select_modal-${id}`" @hidden="recarregar" hide-footer size="xl" :title="btnLabel">
            <component :is='btnTipo' @salvo="fecharCadastro" :modal='true' />
        </b-modal>
        <b-modal :id="`modal-${id}`" @hidden="$emit('hidden')" :title="modalTitle" size="xl" scrollable  ok-only>
            <b-input-group class="mb-3">
                <template #prepend>
                    <b-form-select v-model="modal.term" :options="modalFields.map(el => {return {value : el.key, text : el.label}}).filter(el => el.value != 'acoes')"/>
                </template>
                <b-form-input :placeholder="placeholder" v-model="modal.filter"></b-form-input>
                
                <b-button v-if="btnInserir && controles" @click="abrirCadastro" class="ml-2" variant="info">
                    <i class="fas fa-plus mr-2"></i>
                    {{btnLabel}}
                </b-button>
            </b-input-group>

            <b-table  head-variant="dark" hover :items="filteredItems.filter(el => {return el[modal.term].toLowerCase().includes(modal.filter.toLowerCase())})" :fields="modalFields">
                <template #cell(acoes)="data">
                    <b-form-checkbox
                    v-model="modal.selected"
                    :name="`checkbox-modal-${id}`"
                    :value="data.item.id"
                    @change="update( data.item)"
                    ></b-form-checkbox>
                </template>
                <template v-slot:[`cell(${slotImage})`]="data">
                    <b-avatar  :src="data.value"></b-avatar>
                </template>
            </b-table>
        </b-modal>

        <div>
            <slot name="after-button"/>

            <div class="d-inline-flex align-content-center" v-if="(!hideButton && controles) || title">
                <h4 style="line-height: 35px;">{{title}}</h4>
                <div class="ml-2 mb-2 d-flex" v-if="!hideButton" :class="classButton">
                    <b-button v-if="controles && !esconderInserir" :variant="variantButton" :size="sizeButton" @click="openModal">
                        <i class="fa-solid fa-plus mr-2"></i>                    
                        {{placeholderButton}}
                    </b-button>
                    <slot name="append-button" />
                </div>
            </div>

            <slot name="before-table"/>
            
            <slot name="table">
                <accordion
                    :id="`${accordionId}-fix`" 
                    :title="accordionTitle"
                    sub
                    :accordion="accordionId"
                    :hideTitle="accordionTitle == ''"
                    visible
                    :no-border-collapse="!borderCollapse"
                >
                    <template #append-title>
                        <div>
                            <b-button :variant="variantButton" v-if="controles && !esconderInserir" class="ml-2" @click="clicado" size="sm">
                                <i class="fa-solid fa-plus mr-1"></i>
                                {{placeholderButton}}
                            </b-button>
                        </div>
                    </template>
                    <div :class="accordionTitle != '' ? 'p-3' : ''"    >
                        <div class="table-responsive" >
                            <b-table head-variant="dark" hover :items="values" :fields="fields">
                                <template v-slot:[`cell(${slotImg})`]="data">
                                    <b-avatar  :src="data.value"></b-avatar>
                                </template>
                                <template #cell(edit)="data">
                                    <b-button v-if="controles && !esconderEditar" variant="flat-info" class="mr-2" @click="$emit('edit', data.item)"><i class="fas fa-edit"></i></b-button>
                                </template>
                                <template #cell(remove)="data">
                                    <slot name="btn-remove" v-bind:item="data.item">
                                        <b-button v-if="controles && !esconderExcluir" variant="flat-danger" class="mr-2"  @click="$emit('remove', data.item)"><i class="fas fa-trash"></i></b-button>
                                    </slot>
                                </template>
                                <template #cell(actions)="data">
                                    <div class="d-inline-flex" v-if="controles">
                                        <b-button variant="flat-primary" class="mr-2" v-if="!esconderEditar"  @click="$emit('edit', data.item)"><i class="fas fa-edit"></i></b-button>
                                        <b-button variant="flat-danger" class="mr-2"  v-if="!esconderExcluir" @click="$emit('remove', data.item)"><i class="fas fa-trash"></i></b-button>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </accordion>
            </slot>
        </div>

    </div>
</template>
<script>

import Swal from "sweetalert2";
import Accordion from '@/components/card/Accordion';

export default {
    emits : ['update'],
    components : {
        Accordion,
        'pessoas' : () => import('@/views/pessoas/Formulario.vue'),
    },
    props : {
        id: {
            type: String,
            default: null,
        },
        fetchMethod: {
            type: Function,
            default: null,
        },
        termInitial: {
            type: String,
            default: "",
        },
        modalFields: {
            type: Array,
            default: () => [],
        },
        fields: {
            type: Array,
            default: () => [],
        },
        values : {
            type : Array,
            default : () => []
        },
        placeholder : {
            type : String,
            default : ""
        },
        placeholderButton : {
            type : String,
            default : ""
        },
        variantButton : {
            type : String,
            default : "info"
        },
        sizeButton : {
            type : String,
            default : ""
        },
        title : {
            type : String,
            default : ""
        },
        slotImage : {
            type : String,
            default : "avatar"
        },
        hideSelected:{
            type: Boolean,
            default : false
        },
        functionMap:{
            type: Function,
            default: el => el.id
        },
        controles:{
            type: Boolean,
            default: true
        },
        classButton:{
            type: String,
        },
        hideButton:{
            type: Boolean,
            default: false
        },

        accordionTitle : {
            type : String,
            default : ""
        },
        accordionId : {
            type : String,
            default : ""
        },
        borderCollapse : {
            type : Boolean,
            default : false
        },
        modalTitle : {
            type : String,
            default : ""
        },
        btnInserir : {
            type : Boolean,
            default : false,
        },
        btnTipo : {
            default : ''
        },
        slotTabelaImage : {
            type : String,
            default : null
        },
        esconderInserir : {
            type : Boolean,
            default : false
        },
        esconderEditar : {
            type : Boolean,
            default : false
        },
        esconderExcluir : {
            type : Boolean,
            default : false
        },
    },
    data : () => ({
        modal : {
            term : "",
            filter : "",
            selected : [],
            items : [],
        }
    }),
    methods:{
        abrirCadastro : function(){
            this.$bvModal.show(`cadastro_select_modal-${this.id}`);
        },
        fecharCadastro : function(){
            this.$nextTick(() => {
                this.$bvModal.hide(`cadastro_select_modal-${this.id}`);
            });
        },
        recarregar : function(){
            this.carregarConteudo();       

        },

        openModal: function(){
            this.carregarConteudo();            
        },
        fecharModal : function(){
            this.$nextTick(() => {
                this.$bvModal.hide(`modal-${this.id}`);
            });
        },

        carregarConteudo : function(){
            this.fetchMethod().then((result) => {
                this.modal.items = result.data.data.itens ? result.data.data.itens : result.data.data;
                this.$bvModal.show('modal-' + this.id);
            }).catch((err) => {
                Swal.fire({
                title: this.$t("GERAL.ERRO"),
                text: err.response.data.errors,
                icon: "error",
                });
            });
        },

        update: function(item){            
            this.$emit("update", {item : item, selected : this.modal.selected.some(el => el == item.id)});
        },

        
        clicado(e) {
            e.stopPropagation();
            this.openModal();
        }
        
    },
    mounted: function(){
        this.modal.selected = this.values.map(this.functionMap);
        this.modal.term = this.termInitial;
    },
    watch : {
        values : function(newValue){
            this.modal.selected = (newValue ? newValue.map(this.functionMap) : []);
        }
    },
    computed:{
        slotImg(){
            return this.slotTabelaImage ? this.slotTabelaImage : this.slotImage;
        },
        filteredItems: function(){
            if(this.hideSelected){
                return this.modal.items.filter(el => {
                    return !this.modal.selected.includes(el.id)
                });
            }else{
                return this.modal.items;
            }
        },
        btnLabel : function(){
            switch(this.btnTipo){
                case 'pessoas' : return 'Cadastrar nova pessoa';
                default : return '';
            }
        }
    }

};
</script>
<style>
    .card, .table-responsive {
        min-height: inherit !important;
    }
    .modal-xl{
        max-width: 90% !important;
    }
</style>